<template>
  <div class="footprint-page">

    <ul class="lib-tabs-nav">
      <li role="button" class="nav-item"
          v-for="tab in tabs"
          :key="tab.key"
          @click="handleClick(tab)"
          :class="{'active': tab.key === activeName}">
        <span class="nav-item-text" v-text="tab.name"></span>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeName: '',
      tabs: [
        { key: 'collect', name: '我收藏的产品', route: '/user/footprint/collect', },
        { key: 'resource', name: '我收藏的资源', route: '/user/collect/resource', },
        { key: 'prod', name: '我浏览的产品', route: '/user/footprint/prod' },
        { key: 'comp', name: '我浏览的企业', route: '/user/footprint/comp' },
        { key: 'down', name: '我下载的产品', route: '/user/footprint/down' },
      ],
    };
  },
  watch: {
    $route(to, from){
      this.activeNameCg(to.path);
    },
  },
  mounted() {
    this.activeNameCg();
  },
  methods: {
    activeNameCg(value = '') {
      const path = value || this.$router.history.current.path;
      const pathArr = path.split('/') || [];
      console.log(pathArr[pathArr.length - 1])
      this.activeName = pathArr[pathArr.length - 1];
    },
    handleClick(tab){
      if (this.$router.history.current.fullPath.includes(tab.route)) {
        return false;
      }
      this.$router.replace(tab.route);
    }
  },
};
</script>
<style lang="less" scoped>

.footprint-page {
  padding-top: 32px;
}

.lib-tabs-nav {
  color: #333;
  font-size: 15px;
  font-weight: 500;
  line-height: 32px;
  list-style: none;
  border-bottom: 1px solid #D6D6D6;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  background: #ffffff;
  z-index: 99;
  /*tab标签*/
  .nav-item {
    display: inline-block;
    font-weight: 400;
    padding: 0 4px;
    cursor: pointer;
  }
  .nav-item span {
    display: inline-block;
  }
  .nav-item-text {
    padding: 0 10px;
    color: #999;
  }
  .nav-item.active .nav-item-text {
    color: #333333;
    font-weight: bold;
  }
}
</style>